import axios from 'axios';
import { endpoints } from '../../../common/endpoints';
import buildRequest from '../../buildRequest';
import { stGetToken } from '../../storage';

export const apiDashboardOportunidadEtapas = async params => {
  const url = `${process.env.REACT_APP_api}${endpoints.dashboardOportunidadEtapas}`;
  const method = 'get';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const { data: token } = stGetToken();

  const request = {
    fechaInicio: params.fechaInicio,
    fechaFin: params.fechaFin,
    aliadoId: params.aliadoId,
  };

  try {
    const response = await axios[method](url, buildRequest(token, request));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};
export const apiVentasPorMes = async params => {
  const url = `${process.env.REACT_APP_api}${endpoints.dashboardVentasMes}`;
  const method = 'get';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const { data: token } = stGetToken();

  const request = {
    filtroYear: params.filtroYear,
    aliadoId: params.aliadoId,
  };

  try {
    const response = await axios[method](url, buildRequest(token, request));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};
export const apiCanalizacionVentas = async params => {
  const url = `${process.env.REACT_APP_api}${endpoints.dashboardCanalizacion}`;
  const method = 'get';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const { data: token } = stGetToken();

  const request = {
    filtroMes: params.filtroMes,
    aliadoId: params.aliadoId,
  };

  try {
    const response = await axios[method](url, buildRequest(token, request));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};

export const apiDivisas = async () => {
  const url = `${process.env.REACT_APP_api}${endpoints.divisas}`;
  const method = 'get';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const { data: token } = stGetToken();

  try {
    const response = await axios[method](url, buildRequest(token));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
    dataResponse.success = true;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};
